import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import EditPhoto from "../form/EditPhoto";
import { deletePhoto } from '../redux/userSlice';

const UserPhoto = ({ image, id, ownerId, camera, aperture, shutter_speed, iso, lens, location, time, category, weather, notes, handleDeleteUserPhoto, handleUpdatePhoto }) => {

    const dispatch = useDispatch();
    const history = useHistory()
    const [showUpdate, setShowUpdate ] = useState(false) 

    const handleDetails = () => {
        history.push(`/photo/${id}`)
    }

    const handleShowUpdate = () => {
        setShowUpdate(showUpdate => !showUpdate)
    }

    const handleDelete = () =>{
        fetch(`https://fotoset.herokuapp.com/photos/${id}`, {
            method: "DELETE",
        })
        .then((r) => r.json())
        .then((userPhoto) => {
            handleDeleteUserPhoto(userPhoto)
            dispatch(deletePhoto(userPhoto))
        })
    }

    return(
<>
    <div className="user-photo-container">
        <div className="main-container">
            <div className="user-photo-card">
                <div id="user-image">
                    <img src={image} onClick={handleDetails} alt="user-img" className="user-image"/>
                </div>
                <p>{time}</p>
            </div>
        </div>
        <div className="btn-div">
            {/* <button className="delete-btn" onClick={() => {handleDelete(id)}}>DELETE</button> */}
            <button className="delete-btn" onClick={() => {
                const confirmBox = window.confirm("Do you really want to delete this photo?"
                )
                if(confirmBox === true) {
                    handleDelete(id)
                }
            }}>
                DELETE
            </button>
            <button className="delete-btn" onClick={handleShowUpdate}>EDIT</button>
        </div>
    </div>
            {showUpdate ? <EditPhoto 
                            handleUpdatePhoto={handleUpdatePhoto}
                            id={id}
                            image={image}
                            ownerId={ownerId}
                            camera={camera}
                            aperture={aperture}
                            shutter_speed={shutter_speed}
                            iso={iso}
                            lens={lens}
                            location={location}
                            time={time}
                            category={category}
                            weather={weather}
                            notes={notes}
                            /> 
                    : null}
</>
    )
}

export default UserPhoto;